export const defaults = {
  dir: 'dist',
  repo: undefined,
  message: 'Auto-generated commit',
  branch: 'gh-pages',
  name: undefined,
  email: undefined,
  dotfiles: true,
  notfound: true,
  nojekyll: true,
  cname: undefined,
  add: false,
  dryRun: false,
  remote: 'origin',
  git: 'git'
};
